/**
 * Copyright © 2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { getMinutesMs } from "@farmlands/utilities";
import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";

import { isFarmlandsProApiAccountNumberApplied } from "../../../../services/farmlandspro-api";
import { useBranch } from "../../../../util/useBranch";
import { selectCurrentFarmerAccount } from "../../../azure-b2c/storage";
import { fetchProduct } from "../productsApi";

export const getProductDetailsQueryKey = (
  masterProductId: string | number | undefined,
  accountNumber: string | undefined,
  branchId: string | undefined
) => ["product-details", masterProductId, accountNumber, branchId] as const;

export const useProductDetails = (masterProductId: string | number | undefined, enabled = true) => {
  const currentAccount = useSelector(selectCurrentFarmerAccount);
  const branchId = useBranch();
  const accountNumber = currentAccount?.accountNumber;
  const id = masterProductId?.toString();

  return useQuery({
    queryKey: getProductDetailsQueryKey(id, accountNumber, branchId),
    queryFn: () => fetchProduct(id!, accountNumber!, branchId!),
    enabled: enabled && !!id && !!branchId && isFarmlandsProApiAccountNumberApplied(accountNumber),
    staleTime: getMinutesMs(10),
    gcTime: getMinutesMs(30),
  });
};
